import React from 'react'

export const Information = () => (
  <div>
    <h2>Information Page</h2>
    <p>This is mostly about us.</p>
  </div>
)